<template>
  <div class="wrap">
    <div class="nav" :class="menuPointer ? 'pEvents' : 'pEventsAuto'">
      <img
        src="../assets/img/nav/logo.png"
        alt=""
        srcset=""
        class="game-logo"
      />

      <div class="menu">
        <nav>
          <ul class="header-nav_list">
            <li
              class="header-nav_item"
              v-for="item in navlist"
              :key="item.id"
              @click="handleNav(item.id)"
              :class="menuPointer ? 'pEvents' : 'pEventsAuto'"
            >
              <img :src="activeIndex == item.id ? item.activeUrl : item.url" />
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="blog" :class="menuPointer ? 'pEvents' : 'pEventsAuto'">
      <div class="b-icon">
        <!-- <div>
          <img
            src="../assets/img/nav/login-icon.png"
            alt=""
            srcset=""
            class="t-login-icon"
            v-if="loginFlag"
            @click="showLogin()"
          />
          <img
            src="../assets/img/nav/logout-icon.png"
            alt=""
            srcset=""
            class="t-login-icon"
            v-else
            @click="logout()"
          />
        </div> -->
        <img
          v-for="idx in 4"
          :key="idx"
          :src="require('../assets/img/nav/c-' + idx + '.png')"
          alt=""
          srcset=""
          @click="handleIcon(idx)"
        />
      </div>

      <div class="reg_btn">
        <img class="icon gg-pad cursor" src="../assets/img/nav/gg.png" @click="handlegGP('gp')"/>
        <img class="icon cursor" src="../assets/img/nav/as.png"  @click="handlegIOS('ios')"/>
        <img class="icon cursor" src="../assets/img/nav/os.png"  @click="handlegOS('os')"/>
      </div>
      <img
        class="tvc_btn cursor"
        src="../assets/img/nav/TVC_btn.png"
        @click="tvcVideoModel = true"
      />
      <img
        class="watefull-btn cursor"
        src="../assets/img/nav/watefull-btn.png"
        @click="aechiveModel = true"
      />
    </div>
    <!-- 点击显示底栏的按钮 -->
    <div class="copyright-btn cursor" @click="cRightFlag = !cRightFlag">
      LEGAL
    </div>
    <div class="page">
      <swiper
        :options="swiperOption"
        ref="goodSwiper"
        @slideChange="slideChange"
      >
        <swiper-slide>
          <layer1 />
        </swiper-slide>
        <swiper-slide>
          <gameBenefits />
        </swiper-slide>
        <swiper-slide>
          <layer3 ref="layer3" />
        </swiper-slide>
        <swiper-slide>
          <layer4 @handleTVCModel="tvcVideoModel = true"/>
        </swiper-slide>
      </swiper>
    </div>


    <!-- 提示复制成功 -->
    <div class="model copy-model" v-if="copyModel">
      <img
        src="../assets/img/nav/copyAlert.png"
        alt=""
        srcset=""
        class="copyAlert"
        @click="copyModel = false"
      />
    </div>
    <!-- 底栏 copyright -->
    <div :class="cRightFlag ? 'f-open' : ''" class="f-copyright">
      <img src="../assets/img/nav/t-1.png" alt="" srcset="" class="t-1" />
      <div class="t-2">
        <a href="https://useragreement-kr.ujoygames.co.kr/" target="_blank">
          <div class="btn-privacypolicy cursor"></div>
        </a>
        <a href="https://privacypolicy-kr.ujoygames.co.kr/" target="_blank">
          <div class="btn-useragreement cursor"></div>
        </a>
      </div>
    </div>
    <!-- 点击显示aechive弹出框 -->
    <div
      class="model aechive-model"
      v-if="aechiveModel"
      @click="aechiveModel = false"
    >
      <div class="aechive-cnt">
        <pAechive />
      </div>
    </div>
   
    <!-- tvc视频 -->
     <div
      v-if="tvcVideoModel"
      class="model position-fixed"
      @click="tvcVideoModel = false"
    >
      <div class="v-txt">
        <iframe
          width="100%"
          height="100%" 
          src="https://www.youtube.com/embed/Akh0LlSBOio?si=rNWkg9XZU27H9IEO"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import layer1 from "./publicComponents/layer1";
import layer3 from "./publicComponents/layer3";
import layer4 from "./publicComponents/layer4";
import gameBenefits from "./publicComponents/gameBenefits";
import pAechive from "./publicComponents/pupAechive";

let _y = 0;
let _isEnd = false;

export default {
  components: {
    layer1,
    layer3,
    layer4,
    gameBenefits,
    pAechive
  },
  data() {
    return {
      tvcVideoModel: false,
      nextShow: true,
      swiperOption: {
        direction: "vertical",
        slidesPerView: "auto",
        allowTouchMove: false,
        slideToClickedSlide: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        mousewheel: true, //开启鼠标
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0,
        breakpoints: {
          780: {
            allowTouchMove: true
          }
        }
      },
      // menu
      navlist: [
        {
          id: 1,
          url: require("../assets/img/nav/1.png"),
          activeUrl: require("../assets/img/nav/1-active.png")
        },

        {
          id: 2,
          url: require("../assets/img/nav/2.png"),
          activeUrl: require("../assets/img/nav/2-active.png")
        },
        {
          id: 3,
          url: require("../assets/img/nav/5.png"),
          activeUrl: require("../assets/img/nav/5-active.png")
        },
        {
          id: 4,
          url: require("../assets/img/nav/6.png"),
          activeUrl: require("../assets/img/nav/6-active.png")
        }
      ],
      activeIndex: 1,
      menuPointer: false,
     
      copyModel: false, // 提示复制成功
      cRightFlag: false, // 是否显示底栏copyright
      aechiveModel: false, // 显示aechiveModel
      realtimeRewardUser: "" // 底栏跑马灯内容
    };
  },
  created() {
    // 基础数据接口
    this.handleInfo();
  },
  updated() {},

  mouthed() {},
  watch: {},
  computed: {},
  methods: {
   
    // info基础数据
    handleInfo() {
      let account;
      const flowerMobile = localStorage.getItem("flower-v3-mobile");
      if (flowerMobile) {
        account = flowerMobile.replace(/^0*82/, "");
      } else {
        account = "";
      }
      const reqTime = Math.floor(new Date().getTime() / 1000);
      // const account = "92223333";
      const code = 82; // code可以不用传
      this.$axios({
        method: "post",
        url: "https://api-register.ujoygames.com/flower/info",
        data: {
          signature: this.common.makeSignature({}, reqTime),
          reqTime,
          account,
          code
        },
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          const data = res.data.data;
          localStorage.setItem(
            "flower-v3-canLottery",
            JSON.stringify(data.canLottery)
          );
          localStorage.setItem("flower-v3-rewards", JSON.stringify(data.rewards));
          localStorage.setItem(
            "flower-v3-postInfo",
            JSON.stringify(data.postInfo)
          );
          localStorage.setItem(
            "flower-v3-realtimeRewardUser",
            JSON.stringify(data.realtimeRewardUser)
          );
          localStorage.setItem(
            "flower-v3-feedInfo",
            JSON.stringify(data.feedInfo)
          );
          localStorage.setItem("flower-v3-uuid", JSON.stringify(data.uuid));

          // 跑马灯内容
          this.realtimeRewardUser = data.realtimeRewardUser;

          // 判断是否已经登录过了
          this.isLoginIn();
        })
        .catch(err => {});
    },
    

    // 改变菜单和顶栏的z-index
    handleMenuIndex(val) {
      this.menuPointer = val;
      if (val) {
        this.$refs.goodSwiper.swiper.mousewheel.disable();
      } else {
        this.$refs.goodSwiper.swiper.mousewheel.enable();
      }
    },
    // 按钮点击跳转
    handleIcon(val) {
      if (val == 1) {
        this.common.goShare("cafe");
      } else if (val == 2) {
        this.common.goShare("ins");
      } else if (val == 3) {
        this.onCopy();
      } else if (val == 4) {
        this.common.goShare("ko");
      }
    },
    // 点击按钮跳转
    handlegGP(val) {
       this.common.goShare(val);
    },
  handlegIOS(val) {
       this.common.goShare(val);
    },
      handlegOS(val) {
       this.common.goShare(val);
    },
    // 复制按钮
    onCopy() {
      let url = "https://flower.ujoygames.com/";
      var oInput = document.createElement("input"); //创建一个隐藏input（重要！）
      oInput.value = url; //赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      this.copyModel = true;
    },

    // 菜单
    handleNav(val) {
      this.activeIndex = val;
      const hcon = this.$refs.goodSwiper.swiper;
      if (val == 1) {
        hcon.slideTo(0, 300);
      } else if (val == 2) {
        hcon.slideTo(1, 300);
      } else if (val == 3) {
        hcon.slideTo(2, 300);
      } else if (val == 4) {
        hcon.slideTo(3, 300);
      }
    },

    slideChange() {
      const mainActiveIndex = this.$refs.goodSwiper.swiper.activeIndex;
      this.activeIndex = mainActiveIndex + 1;
      if (mainActiveIndex == 1) {
        // this.initData();
      }
    }
  }
};
</script>
<style lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #000;

  .pEvents {
    pointer-events: none;
    opacity: 0.5;
  }
  .pEventsAuto {
    pointer-events: auto;
    opacity: 1;
  }
  #copyright {
    height: 190px;
    width: 100%;
  }
  .copy-model {
    position: fixed;

    .copyAlert {
      width: 420px;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  // 轮播

  .page {
    .swiper-container {
      width: 100%;
      height: 100%;
    }
  }

  //点击提示去h5抽奖
  .watefull-model {
    position: absolute;

    img {
      width: 500px;
      height: auto;
    }
  }

  .lottery-reg {
  }
}
@media screen and (max-width: 1200px) {
  .nav {
    top: 16vw !important;
  }
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .nav {
    top: 4vw !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainIndex.vue